export const DateFormatter = Symbol('DateFormatter');
